// =============================================================================
// SITE CONFIGURATION — Le Coup de Torchon (Paris 5e)
// =============================================================================
// Master configuration for Le Coup de Torchon restaurant website.
// Controls styling, localization, reservations, SEO, and integrations.
// =============================================================================

import type { SiteConfig } from '@webzite/content-schema';

const siteConfig: SiteConfig = {
  // =========================================================================
  // VISUAL STYLE
  // =========================================================================
  // Red Velvet Bistro style pack — deep red velvet, noir black, amber gold.
  stylePack: 'red-velvet-bistro',

  // =========================================================================
  // GEOGRAPHIC REGION
  // =========================================================================
  // European Union — EU-14 allergen regulations, GDPR cookie consent.
  region: 'eu',

  // =========================================================================
  // LANGUAGE & LOCALIZATION
  // =========================================================================
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'zh', 'de', 'it', 'pt'],
  currency: 'EUR',

  // =========================================================================
  // RESERVATIONS
  // =========================================================================
  reservations: {
    enabled: true,
    provider: 'custom',
    bookingUrl: 'tel:+33146332293',
  },

  // =========================================================================
  // DELIVERY PLATFORMS
  // =========================================================================
  delivery: {
    enabled: false,
    platforms: [],
  },

  // =========================================================================
  // MAP
  // =========================================================================
  maps: {
    provider: 'osm',
    embedUrl:
      'https://www.openstreetmap.org/export/embed.html?bbox=2.3370,48.8425,2.3480,48.8475&layer=mapnik&marker=48.8452,2.3425',
    googleMapsLink:
      'https://www.google.com/maps/place/Le+Coup+de+Torchon/@48.8452026,2.3399728,17z/data=!4m6!3m5!1s0x47e671c2bc273cdd:0xb0da0aa9ef3e5edf!8m2!3d48.8452026!4d2.3425477!16s%2Fg%2F1trvkrf0',
    appleMapsLink:
      'https://maps.apple.com/?q=Le+Coup+de+Torchon+187+Rue+Saint-Jacques+75005+Paris',
  },

  // =========================================================================
  // ANALYTICS
  // =========================================================================
  analytics: {
    cloudflare: { enabled: true },
    ga4: {
      enabled: false,
      measurementId: '',
    },
  },

  // =========================================================================
  // SEO (Search Engine Optimization)
  // =========================================================================
  seo: {
    titleTemplate: '%s | Le Coup de Torchon — Bistrot Parisien Paris 5e',
    defaultDescription:
      'Bistrot traditionnel français au 187 Rue Saint-Jacques, Paris 5e (Panthéon / Luxembourg). Cuisine maison, formules généreuses et ambiance feutrée depuis 1988.',
    ogImage: '/images/og-image.png',
  },

  // =========================================================================
  // DEVELOPER ATTRIBUTION & WATERMARK
  // =========================================================================
  developer: {
    name: 'jeduapf',
    url: 'https://portfolio.jeduapf.com',
    role: 'Restaurant Web Developer',
    showFooterCredit: true,
  },

  // =========================================================================
  // ALLERGEN REGULATION
  // =========================================================================
  allergenRegulation: 'eu-fic-1169',
};

export default siteConfig;
